export default function PrivacyPolicy() {
  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />

          <h1>Privacy Policy</h1>

          <h3>English</h3>
          <p>
            EduAt10 respects your privacy. We collect only necessary information
            such as name, email, and phone number to provide educational services.
          </p>
          <p>
            We do not sell or share personal data except for payment processing
            via Razorpay.
          </p>

          <h3>हिंदी</h3>
          <p>
            EduAt10 आपकी गोपनीयता का सम्मान करता है। हम केवल आवश्यक जानकारी ही
            एकत्र करते हैं।
          </p>
          <p>
            आपकी जानकारी Razorpay भुगतान प्रक्रिया के अलावा साझा नहीं की जाती।
          </p>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  background: "rgba(255,255,255,0.95)",
  maxWidth: 900,
  margin: "auto",
  padding: 30,
  borderRadius: 16,
};

const logoStyle = {
  width: 120,
  display: "block",
  margin: "0 auto 20px",
};
